import { render, staticRenderFns } from "./xc-base_table_search.vue?vue&type=template&id=9cc3d8fa&scoped=true"
import script from "./xc-base_table_search.vue?vue&type=script&lang=js"
export * from "./xc-base_table_search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc3d8fa",
  null
  
)

export default component.exports